/**
 * Simple, unsophisticated function to dedupe an array of objects by comparing their serialized values.
 *
 * @param array what you want deduplicated
 * @returns the deduped array or undefined if the input was undefined
 */
export function dedupeSerializableObjects<T>(
  array: T[] | undefined
): T[] | undefined {
  if (!array) {
    return;
  }
  const result: T[] = [];
  const set = new Set<string>();
  for (const value of array) {
    if (!set.has(JSON.stringify(value))) {
      set.add(JSON.stringify(value));
      result.push(value);
    }
  }
  return result;
}
